<template>
  <common-modal
    :name="name"
    :title="title"
    :primaryAction="primaryAction"
    :secondaryActions="secondaryActions"
    :on-closed="closeModal"
    height="auto"
    :width="generateWidth"
  >
    <template #modal-body>
      <validation-form @on-submit="saveForm" ref="changePassword">
        <div
          class="md-layout-item mb-8"
          :class="styleErrorServer('old_password')"
          v-if="!$can(All.actions, All.subject)"
        >
          <validation-field
            :validations="validationsStudent.password"
            :field-class="getValidationClass('old_password')"
            name="old password"
          >
            <label>{{ $t("change_password.old_password") }}</label>
            <md-input
              required
              type="password"
              v-model.trim="form.old_password"
              autocomplete="off"
            ></md-input>
            <span class="md-error" v-if="serverValidations.old_password">{{
              serverValidations.old_password
            }}</span>
          </validation-field>
        </div>

        <div
          class="md-layout-item mb-8"
          :class="styleErrorServer('new_password')"
        >
          <validation-field
            :validations="validationsStudent.password"
            :field-class="getValidationClass('new_password')"
            name="new password"
          >
            <label>{{ $t("change_password.new_password") }}</label>
            <md-input
              required
              type="password"
              v-model.trim="form.new_password"
              autocomplete="off"
            ></md-input>
            <span class="md-error" v-if="serverValidations.new_password">{{
              serverValidations.new_password
            }}</span>
          </validation-field>
        </div>

        <div
          class="md-layout-item mb-8"
          :class="styleErrorServer('confirm_new_password')"
        >
          <validation-field
            :validations="validationsStudent.password"
            :field-class="getValidationClass('confirm_new_password')"
            name="confirm new password"
          >
            <label>{{ $t("change_password.confirm_new_password") }}</label>
            <md-input
              required
              type="password"
              v-model.trim="form.confirm_new_password"
              autocomplete="off"
            ></md-input>
            <span
              class="md-error"
              v-if="serverValidations.confirm_new_password"
              >{{ serverValidations.confirm_new_password }}</span
            >
          </validation-field>
        </div>
      </validation-form>
    </template>
  </common-modal>
</template>

<script>
import CommonModal from "@/components/Base/CommonModal";
import { service_paths } from "@/constants/Services";
import { Message, genErrMsgOj } from "@/helpers/utils";
import { validations } from "@/validations/students";
import { All } from "@/constants/Permissions";

const defaultModal = () => ({
  old_password: null,
  new_password: null,
  confirm_new_password: null
});
export default {
  components: { CommonModal },
  props: ["name", "title", "uuid"],
  data() {
    return {
      generateWidth: null,
      All,
      primaryAction: {
        title: "change_password.change",
        action: this.doSubmit
      },
      secondaryActions: [
        {
          title: "common.cancel",
          action: this.closeModal
        }
      ],
      form: defaultModal(),
      validationsStudent: validations,
      serverValidations: {}
    };
  },
  watch: {
    "form.old_password": function() {
      this.serverValidations.old_password &&
        delete this.serverValidations.old_password;
    },
    "form.new_password": function() {
      this.serverValidations.new_password &&
        delete this.serverValidations.new_password;
    },
    "form.confirm_new_password": function() {
      this.serverValidations.confirm_new_password &&
        delete this.serverValidations.confirm_new_password;
    }
  },
  created() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.generateWidth = window.innerWidth < 599 ? "95%" : "500px";
    },
    doSubmit() {
      this.$refs.changePassword.submitForm();
    },

    saveForm() {
      this.$axios
        .post(`${service_paths.users}/${this.uuid}/update-password`, this.form)
        .then(() => {
          this.closeModal();
          Message.success(
            this.$t("change_password.change_password_successfully")
          );
        })
        .catch(error => {
          const errData = error.response?.data;
          if (errData) {
            this.serverValidations = genErrMsgOj(errData.message);
          }
        });
    },

    closeModal() {
      this.$modal.hide(this.name);
      this.form = defaultModal();
    },

    getValidationClass(fieldName) {
      return {
        "md-invalid": !!this.serverValidations[fieldName]
      };
    },

    styleErrorServer(fieldName) {
      return {
        "mb-40": !!this.serverValidations[fieldName]
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.mb-40 {
  margin-bottom: 40px !important;
}
.md-error {
  top: 40px;
}
</style>

<style lang="scss">
.fixed-plugin.change-pwd {
  top: 110px;
  width: auto;
  background-color: transparent;
}
</style>
